import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MbscDatetimeOptions } from '@mobiscroll/angular';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import * as alertifyjs from 'alertifyjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-code-dynamic',
  templateUrl: './code-dynamic.component.html',
  styleUrls: ['./code-dynamic.component.css']
})
export class CodeDynamicComponent implements OnInit, OnDestroy {
  loadingXls:any;
  type:any = 'CODIGO_DINAMICO_MASIVAMENTE';
  fileName = '';
  formDataUpload:any = null;
  trace_documets:any = [];
  loadingXls2:any;
  private pollInterval: any = null;


  mobileSettingsFile: MbscDatetimeOptions = {
    display: 'bottom'
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    public socketService: SocketioService,
    public _auth: AuthService
  ) { }

  private destroyed = false;

  ngOnInit(): void {
    console.log('[code-dynamic] ngOnInit — iniciando polling cada 2s');
    this.getTrace_documets('CODIGO_DINAMICO_MASIVAMENTE');
    this.schedulePoll();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.pollInterval) {
      clearTimeout(this.pollInterval);
      this.pollInterval = null;
    }
  }

  // setTimeout recursivo: nunca overlap, no se queda colgado si un fetch tarda
  private schedulePoll(): void {
    if (this.destroyed) return;
    this.pollInterval = setTimeout(async () => {
      try {
        await this.getTrace_documets('CODIGO_DINAMICO_MASIVAMENTE');
      } catch (e) {
        console.warn('[code-dynamic] poll error (ignorado):', e);
      }
      this.schedulePoll();
    }, 2000);
  }

  reload_noti(){
    this.getTrace_documets('CODIGO_DINAMICO_MASIVAMENTE');
  }

  onFileSelected  = async  (event:any) => {
    const file:File = event.target.files[0];
    if (file) {
        this.fileName = file.name;
        this.formDataUpload = file;
    }
  }


  submit = async () => {
    this.loadingXls = true;
    try {
      const formData = new FormData();
      if (this.formDataUpload) {
       formData.append("file", this.formDataUpload);
      }

      let resp = await this._user.bulk_code_dynamic(formData);
      this.reload_noti();

      alertifyjs.success(`Solicitud para iniciar el código dinámico de clientes exitoso`);
      this.loadingXls = false;
    } catch (error:any) {
      if(error.status == 400 ){
        alertifyjs.error(error.error.msg);
      }else{
        alertifyjs.error(`Error al iniciar el código dinámico de clientes`);
      }
      this.reload_noti();

    }
    this.loadingXls = false;

  }


  public getTrace_documets  = async (type:any) =>{
    try {
      let result = await this._user.traceDocumentsGet({type});
      if (result?.resp) {
        // forzar nuevo array reference para que Angular detecte cambios
        this.trace_documets = [...result.resp];
        const pending = this.trace_documets.filter((t: any) => t?.state === 'PENDING').length;
        if (pending > 0) {
          const t = this.trace_documets.find((x: any) => x?.state === 'PENDING');
          console.log(`[code-dynamic] poll · ${pending} PENDING · ${t?.progress?.percentage}% · ${t?.progress?.current_phase_description || ''}`);
        }
      }
    } catch (error) {
      console.warn('[code-dynamic] getTrace_documets error:', error);
    }

  }


  dowloader_document(url:any){
    let url_f = `${environment.BASE_LA}/${url}`;
    window.open(`${url_f}`);
  }


  // 🆕 Helpers para card moderno
  getElapsedHuman(dateStart: any): string {
    if (!dateStart) return '—';
    const start = new Date(dateStart).getTime();
    if (isNaN(start)) return '—';
    const elapsedSec = Math.floor((Date.now() - start) / 1000);
    if (elapsedSec < 60) return `${elapsedSec}s`;
    if (elapsedSec < 3600) return `${Math.floor(elapsedSec / 60)}m ${elapsedSec % 60}s`;
    return `${Math.floor(elapsedSec / 3600)}h ${Math.floor((elapsedSec % 3600) / 60)}m`;
  }

  getDurationHuman(dateStart: any, dateEnd: any): string {
    if (!dateStart || !dateEnd) return '—';
    const start = new Date(dateStart).getTime();
    const end = new Date(dateEnd).getTime();
    if (isNaN(start) || isNaN(end) || end < start) return '—';
    const sec = Math.floor((end - start) / 1000);
    if (sec < 60) return `${sec}s`;
    if (sec < 3600) return `${Math.floor(sec / 60)}m ${sec % 60}s`;
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${h}h ${m}m ${s}s`;
  }

  // 🆕 Cancelar un trace en ejecución (state=PENDING) — patrón estándar de reportes
  async cancelTrace(item: any) {
    if (!item?._id && !item?.code) return;
    const reason = window.prompt(
      `Vas a detener la carga masiva de etiquetas.\n\nIndica la razón (mínimo 5 caracteres):\n\nEjemplos:\n  • Se subió el Excel equivocado\n  • Necesito corregir el archivo\n  • Reemplazar con otra carga posterior`
    );
    if (reason === null) return;
    const trimmed = (reason || '').trim();
    if (trimmed.length < 5) {
      window.alert('Razón muy corta (mínimo 5 caracteres). No se canceló.');
      return;
    }
    try {
      const result = await this._user.cancelTraceDocument(item?._id || item?.code, trimmed);
      if (result?.ok) {
        this.reload_noti();
      } else {
        window.alert(result?.msg || 'No se pudo cancelar la carga');
      }
    } catch (err: any) {
      console.error('Error cancelando carga:', err);
      window.alert('Error de red al cancelar — reintentar en unos segundos');
    }
  }


}
